import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { Global } from 'src/app/app.global';
import { TriggerComponent } from './../../components/trigger/trigger.component';
import { IUser } from './../../interfaces';
import { IResponse } from './../../interfaces';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor( private _http: HttpClient, private router: Router, private _trigger: TriggerComponent ) { }

  // iniciar sesión con email y password. 
  signInWithEmailAndPassword(credentials: Object) {
    /* Nueva promesa */
    var promise = new Promise<IUser>((resolve, reject) => {
      /* Llamado a la ruta de la API para iniciar sesión */
      this._http.post(Global.url + 'user/signinweb', credentials).toPromise().then((res: IUser) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
    /* Retornamos los datos obtenidos de la API */
    return promise;
  }
  
  // Guards que nos valida si el usuario tiene o no permiso para navegar en la app.
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    /* Retornamos la promesa */
    return new Promise((resolve) => {
      /* Obtenemos las variables almacenadas en las variables locales que usamos al iniciar sesión */ 
      let user_id = JSON.parse(window.localStorage.getItem('uid'));
      let token = window.localStorage.getItem('token');

      /* Validamos que el usuario allá iniciado al menos una vez en la app */
      if(token !== null && user_id !== null){
        /* Verificamos la sesión que el usuario siga con permisos y activo desde el ERP */
        this.verifySessionWithTokenAndUserID(token, user_id['ad_user_id']).then(res => {
          /* Validamos la respuesta, si es si */
          if(res.successful) {
            resolve(true);
          /* Validamos la respuesta, si es no */
          } else {
              /* Retornar a la página del login para que inicie nuevamente */ 
              this.router.navigate(['login']).then(() => {
                localStorage.removeItem('uid');
                localStorage.removeItem('token');
                  resolve(false);
              });         
          }
          /* Si hay errores, porque el token no es válido */
        }).catch(() => {
            /* Retornar a la página del login */
            this.router.navigate(['login']).then(() => {
              /* Limpiamos las variables locales */
               localStorage.removeItem('uid');
                localStorage.removeItem('token');
                /* Mostramos por pantalla mensaje de que sesión ha expirado */
                this._trigger.toastSimple('Tu sesión ha expirado. Para continuar, inicia sesión nuevamente.', 'warning');
                  resolve(false);
            });
        });
        /* Si no ha iniciado sesión que diriga al login */
      } else {
        this.router.navigate(['login']);
         resolve(false);
      }
    });
  }
  
  // Verificar que el usuario tenga aún permisos para estar en la App.
  verifySessionWithTokenAndUserID(token: string, user_id: string){
    /* Nueva promesa */
    var promise = new Promise<IResponse>((resolve, reject) => {
      /* Declaramos la cabecera, osea el Token de seguridad */
      let headers = new HttpHeaders();
      headers = headers.set('authorization', token);
      /* Declaramos los parametros a entregar, osea el ID */
      let params = new HttpParams();
      params = params.append('ad_user_id', user_id);
        /* Llamado a la ruta de la API y entregamos los resultados */
        this._http.get(Global.url + 'user/signin/session', { params: params, headers: headers }).toPromise().then((res: IResponse) => {
          resolve(res);
        }).catch((err) => {
          reject(err);
        });
    });
    /* Retornamos los datos obtenidos de la API */
    return promise;
  }

   // Actualizar el FCM del usuario.
   updateFcmUser(ad_user_id: string) {
    let body = {};
    /* Nueva promesa */
    var promise = new Promise<IResponse>((resolve, reject ) => {
      /* Declaramos la cabecera, osea el Token de seguridad */
      let headers = new HttpHeaders();
      headers = headers.set('authorization', window.localStorage.getItem('token'));
      /* Declaramos los parametros a entregar */
      const params = new HttpParams()
        .append('p_fcm', window.localStorage.getItem('fcm'))
        .append('p_user_id', ad_user_id) 
        /* Llamado a la ruta de la API y entregamos los resultados */
        this._http.post(Global.url + 'user/fcm/', body, { params: params, headers: headers }).toPromise().then((res: IResponse) => {
          resolve(res);
        }).catch((err) => {
          reject(err);
        });
    });
    /* Retornamos los datos obtenidos de la API */
    return promise;
  }

  userByID(ad_user_id: string) {
          /* Nueva promesa */
          var promise = new Promise<IUser>((resolve, reject) => {
              /* Declaramos la cabecera, osea el Token de seguridad */
              let headers = new HttpHeaders();
              headers = headers.set('authorization', window.localStorage.getItem('token'));
              const params = new HttpParams()
                  .append('ad_user_id', ad_user_id)
              /* Llamado a la ruta de la API y entregamos los resultados */
              this._http.get(Global.url + 'user/find/', { params: params, headers: headers }).toPromise().then((res: IUser) => {
                  resolve(res);
              }).catch((err) => {
                  reject(err);
                  console.error('Error en la solicitud:', err);
              });
          });
          /* Retornamos los datos obtenidos de la API */
          return promise;
  
      }


}